/**
 * Stable semantic conventions for OpenTelemetry, accepted and made canon
 * within the OpenTelemetry community.
 */
export {
  ATTR_SERVICE_NAME,
  ATTR_CODE_FILE_PATH,
  ATTR_CODE_FUNCTION_NAME,
  ATTR_CODE_LINE_NUMBER,
  ATTR_CODE_COLUMN_NUMBER,
  ATTR_EXCEPTION_STACKTRACE,
  ATTR_EXCEPTION_MESSAGE,
} from "@opentelemetry/semantic-conventions";

/**
 * Experimental, unstable, and incubating attributes.
 *
 * These should be periodically reviewed and moved to stable attributes
 * when they are ready. They are copied from the OpenTelemetry semanitic conventions
 * repository and may not be stable across versions.
 *
 * Ref: https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv
 */
export const ATTR_DEPLOYMENT_ENVIRONMENT = "deployment.environment";
